import React, { Component, ReactNode, ReactElement } from 'react';
import type { UploadProps } from 'antd';
import { Button, Upload as AntdUpload, message } from 'antd';
// @ts-ignore
import SparkMD5 from 'spark-md5';
import { UploadFile } from 'antd';

import { verifyFile } from './utils';
import { ossSignUrl, getOSSUploadSignUrl, getFileMD5, OSSHeaders } from '@/api/grt/upload';

export enum UploadType {
    // eslint-disable-next-line no-unused-vars
    UNSET,
    // eslint-disable-next-line no-unused-vars
    IMAGE = 4,
    // eslint-disable-next-line no-unused-vars
    VIDEO = 2,
    // eslint-disable-next-line no-unused-vars
    AUDIO,
    // eslint-disable-next-line no-unused-vars
    DOCS = 5,
    // eslint-disable-next-line no-unused-vars
    USER_AVATAR,
    // eslint-disable-next-line no-unused-vars
    APP,
    // eslint-disable-next-line no-unused-vars
    AI = 21,
    AGENT_EVALUATION
}

const acceptTypeStr = '.pdf,.docx,.txt,.md,.html,.epub,.xlsx,.xls,.csv,.pptx,.jpeg,.jpg,.png,.webp';
const acceptTypeArr = ['pdf', 'docx', 'txt', 'md', 'html', 'epub', 'xlsx', 'xls', 'csv', 'pptx', 'jpeg', 'jpg', 'png', 'webp'];
interface genUrlResult {
    success: boolean;
    data: string | undefined | null;
}

export interface Props {
    sizeTip?: string;
    typeTip?: string;
    /** 自定义上传元素*/
    uploadItem?: ReactNode;
    customUploadType?: Array<string>;
    uploadType?: UploadType;
    /** 自定义class*/
    className?: string;
    // eslint-disable-next-line no-unused-vars
    onChange?: (file: UploadFile) => void;
    dirname?: string;
    /** 桶名*/
    bucketName: string;
    /** 上传前回调 /UploadFile类型参考onChange*/
    // eslint-disable-next-line no-unused-vars
    beforeUpload?: (file: UploadFile, name: string, md5: string) => Promise<boolean | undefined | void>;
    /** 上传中回调 /UploadFile类型参考onChange*/
    // eslint-disable-next-line no-unused-vars

    // eslint-disable-next-line no-unused-vars
    processFunc?: (processNumber: number, file: UploadFile, xhr: XMLHttpRequest, obsResult: any) => void;
    /** 上传完成回调 /UploadFile类型参考onChange*/
    // eslint-disable-next-line no-unused-vars

    // eslint-disable-next-line no-unused-vars
    uploadCompleteFunc?: (obsResult: any, file: UploadFile) => void;
    /** 上传失败回调 /UploadFile类型参考onChange*/
    // eslint-disable-next-line no-unused-vars
    // eslint-disable-next-line no-unused-vars
    errorFunc?: (error: any, file: UploadFile, obsResult: any) => void;
    // eslint-disable-next-line no-unused-vars
    itemRender?: (originNode: ReactElement, file: UploadFile, fileList: object[], actions: any) => ReactNode;
    /** 文件大小限制*/
    maxSize?: number;
    /** 多个文件上传*/
    multiple?: boolean;
    disabled?: boolean;
    fileList?: UploadFile[];
}

interface State {
    fileList: UploadFile[];
}

class UsualSkillOssUpload extends Component<Props, State> {
    countHasTip = false;
    state: State = {
        fileList: []
    };

    xhrUploadFile(uploadUrl: string, file: any, headers: any, obsResult: any = {}) {
        const xhr = new XMLHttpRequest();
        xhr.open('put', uploadUrl);
        for (let key in headers) {
            const value = headers[key];
            if (key) {
                xhr.setRequestHeader(key, value);
            }
        }
        xhr.upload.onprogress = (event) => {
            if (event.lengthComputable) {
                if (this.props.processFunc) {
                    this.props.processFunc(event.loaded / event.total, file, xhr, obsResult);
                }
            }
        };
        xhr.onerror = (err) => {
            if (this.props.errorFunc) {
                console.error(err);
                this.props.errorFunc(err, file, obsResult);
            }
        };
        xhr.onload = () => {
            if (xhr.status === 200) {
                if (this.props.uploadCompleteFunc) {
                    const url: string = xhr.responseURL;
                    obsResult.fileUrl = url.substring(0, url.indexOf('?'));
                    this.props.uploadCompleteFunc(obsResult, file);
                }
            }
        };
        xhr.send(file);
        return xhr;
    }

    get uploadItem(): ReactNode {
        return this.props.uploadItem ? this.props.uploadItem : <Button>上传</Button>;
    }

    uploadOption: UploadProps = {
        accept: acceptTypeStr,
        itemRender: this.props.itemRender || (() => null),
        beforeUpload: () => {
            this.countHasTip = false;
            return false;
        },
        multiple: true,
        onChange: async ({ file, fileList }) => {
            if (fileList.length > 5) {
                if (!this.countHasTip) {
                    message.error('单次最多支持5个文件');
                    this.countHasTip = true;
                }
                return false;
            }
            if (file.status) return false;
            const { name } = file;
            let { fileExt } = this.getFileExtAndName(name);
            let res = await verifyFile(file, acceptTypeArr, fileExt);
            console.log(res, 'ressss');
            if (!res) {
                return false;
            }

            // this.setState({ fileList: [...this.state.fileList, file] });
            if (this.props.onChange) {
                this.props.onChange(file);
            }

            await getFileMD5(file).then(async (md5) => {
                const rename = md5 + '.' + fileExt,
                    fileKey = this.props.dirname ? this.props.dirname + '/' + rename : rename;
                if (this.props.beforeUpload) {
                    const beforeFlag = await this.props.beforeUpload(file, fileKey, md5 as string);
                    if (!beforeFlag && beforeFlag !== undefined) return false;
                }
                const { success: ossSuccess, data: ossData } = await getOSSUploadSignUrl(ossSignUrl, this.props.bucketName as string, fileKey);
                console.log(ossData, 'ossData');
                if (ossSuccess) {
                    const url = ossData;
                    this.xhrUploadFile(
                        url,
                        file,
                        { ...OSSHeaders },
                        {
                            bucketName: this.props.bucketName,
                            objectKey: fileKey,
                            type: 'oss',
                            md5,
                            ext: fileExt
                        }
                    );
                }
            });
        }
    };

    getFileExtAndName(fileName: string) {
        const index = fileName.lastIndexOf('.'),
            ext = fileName.substring(index + 1),
            name = fileName.substring(0, index);
        return { fileExt: ext, fileName: name };
    }

    render(): ReactNode {
        return (
            <AntdUpload {...this.uploadOption} fileList={this.props.fileList} disabled={this.props.disabled}>
                {this.uploadItem}
            </AntdUpload>
        );
    }
}

export default UsualSkillOssUpload;
export const getDownloadSignUrl = async (bucket: string, key: string): Promise<genUrlResult> => {
    try {
        const result = await fetch(ossSignUrl, {
            method: 'POST',
            body: JSON.stringify({
                bucketName: bucket,
                objectKey: key,
                method: 'GET'
            })
        });
        return result.json().then((res) => {
            const { success, data } = res;
            if (!success) return { success: false, data: null };
            let { result: SignedResult } = data,
                { SignedUrl: url } = SignedResult;
            return { success: true, data: url };
        });
    } catch (error) {
        console.error(error);
        return { success: false, data: JSON.stringify(error) };
    }
};
